// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"_1zaSO"};